module.exports = __webpack_public_path__ + "assets/img/38_444_big.e86947a5.jpg";